import { lazy, Suspense } from 'react'
import { Link } from 'react-router-dom'
import { StaticComposition } from '../../components/nuclear-background/StaticComposition'
import './HomePage.css'
import { NeutronGameSection } from '../../components/neutron-game/NeutronGameSection'
import { MerchandiseSection } from '../../components/merchandise/MerchandiseSection'
import { HomeSoftwareSection } from '../../components/home/HomeSoftwareSection'
import { EngineeringEnvironmentSection } from '../../components/home/EngineeringEnvironmentSection'
const NuclearBackground = lazy(() => import('../../components/nuclear-background/NuclearBackground'))

export function HomePage() {
  return <><div className="home-canvas">
    <div className="home-background-space"><Suspense fallback={<StaticComposition />}><NuclearBackground /></Suspense></div>
    <section className="home-identity" aria-labelledby="home-title">
      <div className="home-identity__content">
        <h1 id="home-title"><img src="/brand/aldapa-logo.svg" alt="Aldapa Systems" width="326" height="170" /></h1>
        <p>Aldapa Systems develops advanced energy technologies, software, and integrated systems for demanding applications.</p>
        <div className="home-identity__actions">
          <Link className="button button--light" to="/technology">Explore technology <span aria-hidden="true">→</span></Link>
          <Link className="button" to="/software">Explore software <span aria-hidden="true">→</span></Link>
        </div>
      </div>
    </section>
    <button className="home-scroll" type="button" aria-label="Scroll down to the Aldapa Engineering Environment" onClick={() => {
      const section = document.getElementById('engineering-environment')
      if (section) {
        const headerBottom = document.querySelector('.site-header')?.getBoundingClientRect().bottom ?? 0
        window.scrollTo({ top: Math.ceil(window.scrollY + section.getBoundingClientRect().top - headerBottom), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' })
      }
      section?.focus({ preventScroll: true })
    }}><span>Scroll to explore</span><span className="home-scroll__line" aria-hidden="true">↓</span></button>
  </div><EngineeringEnvironmentSection /><HomeSoftwareSection /><MerchandiseSection /><NeutronGameSection /></>
}
